module.exports = __webpack_public_path__ + "img/undraw_real_time_analytics.5500083f.svg";